import type { PropsWithChildren } from "react";
import { Link, NavLink } from "react-router-dom";

interface LayoutProps extends PropsWithChildren {
  apiOnline: boolean | null;
  onLock?: () => void;
  locking?: boolean;
  // Primary sections are shown only for a signed-in workspace.
  navigation?: boolean;
}

export function Layout({ children, apiOnline, onLock, locking = false, navigation = false }: LayoutProps) {
  const connectionLabel = apiOnline === null ? "Connecting" : apiOnline ? "API online" : "API unavailable";
  return (
    <div className="shell">
      <header className="topbar">
        <Link className="brand" to="/" aria-label="Ledgerly home">
          <span className="brand-mark" aria-hidden="true">L</span>
          <span>Ledgerly</span>
        </Link>
        {navigation ? (
          <nav className="primary-nav" aria-label="Sections">
            <NavLink to="/" end>Overview</NavLink>
            <NavLink to="/accounts">Accounts</NavLink>
            <NavLink to="/journal">Journal</NavLink>
            <NavLink to="/planning">Planning</NavLink>
            <NavLink to="/borrowings">Borrowing</NavLink>
            <NavLink to="/books">Books</NavLink>
          </nav>
        ) : null}
        <div className="topbar-actions">
          <span className="connection">
            <span className={`connection-dot ${apiOnline ? "online" : apiOnline === false ? "offline" : ""}`} title={connectionLabel} />
            <span>{connectionLabel}</span>
          </span>
          {onLock ? (
            <button className="icon-button" type="button" onClick={onLock} disabled={locking} aria-label="Lock Ledgerly" title="Lock Ledgerly">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 10V8a6 6 0 0 1 12 0v2M5 10h14v11H5z" /></svg>
            </button>
          ) : null}
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
}
